import React from 'react';

import { Root, Container, Title, SubTitle, ResultStore } from './styles';

// interface AnyReactComponentProps {
//   text: string;
//   lat?: number;
//   lng?: number;
// }

// const AnyReactComponent: React.FC<AnyReactComponentProps> = ({ text }) => (
//   <div>{text}</div>
// );

const StoreLocator: React.FC = () => {
  return (
    <Root>
      <Container>
        <Title>Localize uma Loja</Title>
        <SubTitle>Encontre a loja Super Conecto mais próxima de você!</SubTitle>
        <ResultStore>Lojas Encontradas (3)</ResultStore>
        <div style={{ height: '60vh', width: '80%' }}>
          {/* <MapGL
            width="100%"
            height="500px"
            {...location.viewport}
            mapStyle="mapbox://styles/mapbox/dark-v9"
            onViewportChange={viewport => setLocation({ viewport })}
          >
            <Marker key={1} longitude={-23.497529} latitude={-46.8536804}>
              <span
                style={{
                  fontSize: '18px',
                  padding: '5px',
                  background: '#fc6963',
                }}
              >
                Conecto Sistemas
              </span>
            </Marker>
          </MapGL> */}
          {/* <GoogleMapReact
            bootstrapURLKeys={{
              key: 'AIzaSyCqad-HO86gnD-k-uLrU6SUDuheXR7BK9U',
            }}
            defaultCenter={location.center}
            defaultZoom={location.zoom}
          >
            <AnyReactComponent
              lat={59.955413}
              lng={30.337844}
              text="My Marker"
            />
          </GoogleMapReact> */}
        </div>
      </Container>
    </Root>
  );
};

export default StoreLocator;
